import { DirectiveTutorialPage } from 'components/directive/directiveTutorialPage/DirectiveTutorialPage'
import { GetStaticProps } from 'next'
import { getIntlProps } from 'utils/i18n/getIntlProps'

export default function Page() {
  return <DirectiveTutorialPage directiveType="WILL" />
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  return {
    props: { ...(await getIntlProps(ctx, ['will_lp', 'estate_planning_lp', 'directive'], true)) },
  }
}
